import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function joinWaitlist(payload) {
  const { data } = await axios.post(`${API}/waitlist`, payload);
  return data;
}

export async function membershipRegister(payload) {
  const { data } = await axios.post(`${API}/membership/register`, payload);
  return data;
}

export async function getMembershipStatus(sessionId) {
  const { data } = await axios.get(`${API}/membership/status/${sessionId}`);
  return data;
}

export async function openMembershipPortal(email) {
  const { data } = await axios.post(`${API}/membership/portal`, {
    email,
    origin_url: window.location.origin,
  });
  return data;
}

export async function getPrograms() {
  const { data } = await axios.get(`${API}/programs`);
  return data.programs || [];
}

export async function registerPrograms(payload) {
  const { data } = await axios.post(`${API}/programs/register`, {
    ...payload,
    origin_url: window.location.origin,
  });
  return data;
}

export async function getReenroll(token) {
  const { data } = await axios.get(`${API}/reenroll/${encodeURIComponent(token)}`);
  return data;
}

export async function getProgramCheckoutStatus(sessionId) {
  const { data } = await axios.get(`${API}/programs/checkout/status/${sessionId}`);
  return data;
}

export async function releaseCheckout(registrationId) {
  const { data } = await axios.post(`${API}/lessons/release`, { registration_id: registrationId });
  return data;
}


export async function joinProgramWaitlist(payload) {
  const { data } = await axios.post(`${API}/programs/waitlist`, payload);
  return data;
}

export async function getDisciplineContent(key) {
  const { data } = await axios.get(`${API}/discipline/${key}`);
  return data;
}
